export default __webpack_public_path__ + "static/media/img20.f82d968a.jpg";